export enum iframeEvents {
    HANDLE_RELOAD = "handle_reload"
}